import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import 'react-quill/dist/quill.snow.css';
import {Tabs, Tab} from 'material-ui/Tabs';
import OneQuestion from '../components/OneQuestion';
import {QUIZ} from 'constants/topicTabs';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';

const TOPICS_REQUEST = '/api/v1/tutorials/';
const QUESTIONS_ANSWERS = '/api/v1/results/set_result';
const GET_QUESTION = '/api/v1/first_quiz';
const SUBMIT_ANSWER = '/api/v1/cpd_quizzes';

const TAB_ACTIVE_STYLES = {
  display: 'none'
};

@withRouter
@inject('userStore')
@inject('topicsStore')
@inject('alertStore')
@inject('examPrepHeaderStore')
@observer
class TopicOnlyQuiz extends Component {
  state = {
    selectedTab: QUIZ,
    topic: null,
    answers: [{}],
    selectedQuiz: 0,
    quizResult: null,
    unansweredCount: -1,
  };

  extractContent = description => {
    const span = document.createElement('span');
    span.innerHTML = description;
    return span.textContent || span.innerText;
  }

  componentWillMount() {
    const {topicsStore, match, examPrepHeaderStore: {setTopic}} = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${TOPICS_REQUEST}${id}`).then(data => {
        new HttpClient().get(GET_QUESTION).then(({body}) => {
          console.log(body)
          const quizze = body.first_quiz;
          const quizOptions = quizze.options ? quizze.options : [];
          const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));
          const quiz = {
              ...quizze,
              options
          };
          const topic = data.body.data.tutorial;
          const topicWithVideo = {
            ...topic,
            tutorial_videos_attributes: topic.videos,
            podcasts_attributes: topic.podcasts
          }
          const withDescription = !!this.extractContent(topic.description);
          const topicWithSortedQuizz = {
            ...topicWithVideo,
            withDescription,
            quiz,
          };

          if (topic.tutorial_type !== 'regular') {
            setTopic(topic);
          }

          this.setState({
            topic: topicWithSortedQuizz,
            answers: [{[topicWithSortedQuizz.quiz.id]: []}]
          });
          topicsStore.setTopic(topicWithSortedQuizz);
        });
      }).catch((e) => {
        if(e.status === 403) {
          this.props.history.push('/settings/payments');
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.topicsStore.initNewTopic();
  }

  handleChange = selectedTab => {
    this.setState({selectedTab});
  };

  selectQuiz = selectedQuiz => {
    this.setState({selectedQuiz, quizResult: null});
  }

  onQuestionAnswerEdit = (e, index) => {
    const {id, value} = e.target || {};
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    const options = [...newAnswerObject[id]];
    const answerIndex = options.map(option => Object.keys(option)[0]).indexOf(`answer_${index}`);

    if (answerIndex !== -1) {
      options.splice(answerIndex, 1);
    } else {
      options.push({[`answer_${index}`]: value});
    }

    newAnswerObject[id] = options;

    this.setState({
      answers: newAnswers
    });
  }

  onAnswerEdit = (e, value) => {
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    newAnswerObject[e.target.id] = value;

    this.setState({
      answers: newAnswers
    });
  }

  onNextQuestion = () => {
    const { topic } = this.state;
    const { topicsStore } = this.props;

    new HttpClient().put(`${SUBMIT_ANSWER}/${topic.quiz.id}`).then(({body}) => {
      const quizze = body.next_quiz;
      const unansweredCount = body.unanswered_quizzes_count;
      const quizOptions = quizze.options ? quizze.options : [];
      const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));
      const quiz = {
          ...quizze,
          options
      };

      this.setState({
        unansweredCount,
        topic: {
          ...topic,
          quiz,
        },
        answers: [{[quizze.id]: []}],
      });
      topicsStore.setTopic({
        ...topic,
        quiz,
      });
    });
    // const newAnswers = [...answers];

    // newAnswers.push({ [topic.spd_quizzes[selectedQuiz + 1].id]: '' });

    // this.setState({selectedQuiz: selectedQuiz + 1, answers: newAnswers});

  }

  submitAnswers = event => {
    event.preventDefault();
    const { topic, answers } = this.state;
    // const correctCount = answers.filter(answer => Object.values(answer)[0] === 'true').length;
    const quizCorrects = topic.spd_quizzes.map(quiz => quiz.options.filter(option => option.correct === 'true').length)
    const allAnswers = answers.map(id => id[Object.keys(id)[0]]).map((option) => option.map((answer) => answer[Object.keys(answer)[0]]));
    const correctAnswersLength = allAnswers.map(answer => answer.filter(correct => answer.indexOf('false') === -1 && correct === 'true').length);
    const answersCount = correctAnswersLength.filter((correctLength, index) => quizCorrects[index] === correctLength).length;

    new HttpClient().post(QUESTIONS_ANSWERS, { answers_count: answersCount, id: topic.id })
    .then(response => {
      if(response.body.completed === 'you completed')
        this.setState({quizResult: response.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
    })
    .catch(e => {
      this.setState({quizResult: e.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
    });
  }

  render() {
    const {selectedTab, answers, selectedQuiz, quizResult, unansweredCount} = this.state;
    const {topicsStore} = this.props;

    return (
      <section className="section topic-edit" style={{overflow: 'scroll'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="container justify-content-center">
              <div className="edit-container">

                <Tabs
                  value={selectedTab}
                  onChange={this.handleChange}
                  inkBarStyle={{background: 'transparent'}}
                  className='course-tabs-component'
                >
                  <Tab
                    label="Quiz"
                    value={QUIZ}
                    buttonStyle={TAB_ACTIVE_STYLES}
                  >
                      <OneQuestion
                        id={topicsStore.topic.id}
                        completed={topicsStore.topic.completed || unansweredCount === 0}
                        answer={answers[selectedQuiz]}
                        selectedQuiz={selectedQuiz}
                        quiz={topicsStore.topic.quiz}
                        onAnswerEdit={this.onAnswerEdit}
                        onNextQuestion={this.onNextQuestion}
                        submitAnswers={this.submitAnswers}
                        quizResult={quizResult}
                        selectQuiz={this.selectQuiz}
                        onQuestionAnswerEdit={this.onQuestionAnswerEdit}
                        answers={answers}
                      />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TopicOnlyQuiz;


// WEBPACK FOOTER //
// ./src/modules/topic/containers/TopicOnlyQuiz.js